/* IMENHOF BLOOM — cart-highlight.js
   Markeert het zojuist toegevoegde product in de winkelwagen-drawer en scrollt
   het in beeld, zodat je het meteen vindt — ook bij een lange winkelwagen of
   wanneer de hoeveelheid van een al aanwezig product oploopt.
   Zelfstandig: leest alleen mee (capture-fase) en raakt theme.js niet aan. */
(function () {
  'use strict';
  var drawer = document.getElementById('CartDrawer');
  var body = document.getElementById('CartDrawerBody');
  if (!drawer || !body) return;

  var pendingId = null;
  var pendingAt = 0;
  var WINDOW = 6000;

  /* Onthoud welk variant-id wordt toegevoegd — niet-blokkerend (capture). */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-product-form], [data-quick-add]');
    if (!form) return;
    var idEl = form.querySelector('[name="id"]');
    if (idEl && idEl.value) { pendingId = String(idEl.value); pendingAt = Date.now(); }
  }, true);

  function findLine(id) {
    var lines = body.querySelectorAll('.cart-line[data-key]');
    for (var i = 0; i < lines.length; i++) {
      var key = lines[i].dataset.key || '';
      if (key === id || key.split(':')[0] === id) return lines[i];
    }
    return null;
  }

  function highlight() {
    if (!pendingId || Date.now() - pendingAt > WINDOW) { pendingId = null; return; }
    var line = findLine(pendingId);
    if (!line) return;
    pendingId = null;

    /* animatie betrouwbaar (her)starten */
    line.classList.remove('cart-line--justadded');
    void line.offsetWidth;
    line.classList.add('cart-line--justadded');

    /* in beeld brengen binnen de drawer */
    setTimeout(function () {
      try { line.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
      catch (err) { try { line.scrollIntoView(); } catch (e2) {} }
    }, 360);

    /* accent weer weghalen na de animatie */
    setTimeout(function () { line.classList.remove('cart-line--justadded'); }, 2600);
  }

  var queued = false;
  var obs = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; highlight(); });
  });
  obs.observe(body, { childList: true });
})();
